import { useState } from 'react';
import {
  ConfirmModal,
  GateDeleteModal,
  GateExtendDateModal,
  GateLoadModal,
  GateOutFilterCreateModal,
  GateOutFilterDeleteModal,
  enqueueSnackbar,
} from '../../design-system';
import { GateOutsPage, GateOutsHeader, GateOutsBody } from './GateOutsComponents';
import { RoleGuard } from '../../routes';
import { useStoreTutorial } from '../../context';
import { ContainerGetOneQuery } from '../../types';
import { containersService } from '../../services';
import { i18n } from '../../i18n';
import { GateOutReceiptPrint } from '../containers/GateInReceiptPrint';

export const GateOuts = () => {
  const { tutorial } = useStoreTutorial();

  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);
  const [exportHandler, setExportHandler] = useState<(() => void) | null>(null);
  const [receiptContainer, setReceiptContainer] = useState<ContainerGetOneQuery | null>(null);

  const handlePrintReceipt = (id: string) => {
    containersService
      .get(id)
      .then((res) => setReceiptContainer(res.data.data))
      .catch(() => enqueueSnackbar(i18n.t('pages.gateOutReceipt.loadError'), 'error'));
  };

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, i) => i);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <GateOutsPage
        gridTemplateRows={
          tutorial.isActive ? 'max-content 30rem 1fr' : 'max-content 80% minmax(max-content, 80%)'
        }
        withBottomGap
      >
        <GateOutsHeader totalCount={totalCount} handleExportExcelClick={() => exportHandler?.()} />
        <GateOutsBody
          setData={setData}
          setTotalCount={setTotalCount}
          checkIndexs={checkIndexs}
          setCheckIndexs={setCheckIndexs}
          handleCheckboxChange={handleCheckboxChange}
          setExportHandler={setExportHandler}
          onPrintReceipt={handlePrintReceipt}
        />
      </GateOutsPage>
      <GateExtendDateModal />
      <GateLoadModal />
      <ConfirmModal />
      <GateDeleteModal />
      <GateOutFilterCreateModal />
      <GateOutFilterDeleteModal />
      {receiptContainer && (
        <GateOutReceiptPrint
          container={receiptContainer}
          onPrinted={() => setReceiptContainer(null)}
        />
      )}
    </RoleGuard>
  );
};
